"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFilterConfig = void 0;
const _ = __importStar(require("lodash"));
const config_1 = require("../../config/config");
const TimeUtil_1 = require("../../utils/TimeUtil");
const filters_1 = require("../filters");
const FilterConfig_1 = require("../filters/FilterConfig");
const FilterList_1 = __importDefault(require("../filters/FilterList"));
let filterConfig = new FilterConfig_1.FilterConfig(31, 31, 3, false);
const updateFilterConfig = (newFilterConfig) => {
    filterConfig = new FilterConfig_1.FilterConfig(newFilterConfig.NEW_GAME_PERIOD, newFilterConfig.UPCOMING_GAME_PERIOD, newFilterConfig.NUM_RELATED_GAMES, newFilterConfig.SHOW_GAME_TYPES);
};
exports.updateFilterConfig = updateFilterConfig;
class GameFilterList extends FilterList_1.default {
    constructor() {
        super(...arguments);
        this.copyFromArray = (filters, options) => {
            const gameFilterList = new GameFilterList();
            filters.forEach(filterItem => {
                const { gameTypes, gameStatuses, topPrizes } = options || {};
                let filterValues = null;
                if (filterItem.value === 'gameType' && !!gameTypes) {
                    filterValues = gameTypes;
                }
                else if (filterItem.value === 'gameStatus' && !!gameStatuses) {
                    filterValues = gameStatuses;
                }
                else if (filterItem.value === 'queryTopPrize' && !!topPrizes) {
                    filterValues = topPrizes;
                }
                if (filterValues !== null) {
                    const filtersList = filterItem
                        .getOrdered()
                        .filter(item => filterValues === null || filterValues === void 0 ? void 0 : filterValues.includes(item.value))
                        .map(item => new filters_1.Filter({
                        order: (filterValues === null || filterValues === void 0 ? void 0 : filterValues.indexOf(item.value)) || 0,
                        isSelected: item.isSelected,
                        name: item.name,
                        value: item.value,
                        dateFilterType: item.dateFilterType
                    }))
                        .sort((x, y) => x.order - y.order);
                    gameFilterList.push(new filters_1.FilterListItem(filterItem.type, filterItem.order, filterItem.header, filterItem.name, filterItem.value, filterItem.selectionType, filtersList));
                }
                else {
                    gameFilterList.push(filterItem);
                }
            });
            gameFilterList.map(fl => fl.getOrdered());
            return gameFilterList;
        };
        this.createFixedFilters = (enableQuickDraw) => {
            const gameStatusFilter = new filters_1.FilterListItem('date', -3, 'game.filter.status.label', 'game.filter.status.label', 'gameStatus', filters_1.SelectionType.SINGLE, [
                new filters_1.Filter({
                    order: 0,
                    isSelected: false,
                    name: 'game.filter.status.active',
                    value: 'active',
                    dateFilterType: 'active'
                }),
                new filters_1.Filter({
                    order: 1,
                    isSelected: false,
                    name: 'game.filter.status.endingSoon',
                    value: 'endingSoon',
                    dateFilterType: 'endingSoon'
                }),
                new filters_1.Filter({
                    order: 2,
                    isSelected: false,
                    name: 'game.filter.status.new',
                    value: 'new',
                    dateFilterType: 'new'
                }),
                new filters_1.Filter({
                    order: 3,
                    isSelected: false,
                    name: 'game.filter.status.upcoming',
                    value: 'upcoming',
                    dateFilterType: 'upcoming'
                }),
                new filters_1.Filter({
                    order: 4,
                    isSelected: false,
                    name: 'game.filter.status.ended',
                    value: 'ended',
                    dateFilterType: 'ended'
                })
            ]);
            const fixedGameTypeFilter = [
                new filters_1.Filter({
                    order: 0,
                    isSelected: false,
                    name: 'game.filter.gameTypeId.instant',
                    value: 1
                }),
                new filters_1.Filter({
                    order: 1,
                    isSelected: false,
                    name: 'game.filter.gameTypeId.fastplay',
                    value: 5
                }),
                new filters_1.Filter({
                    order: 2,
                    isSelected: false,
                    name: 'game.filter.gameTypeId.draw',
                    value: 2
                })
            ];
            const allGameTypeFilters = [
                ...fixedGameTypeFilter,
                new filters_1.Filter({
                    order: 3,
                    isSelected: false,
                    name: 'game.filter.gameTypeId.quickDraw',
                    value: 7
                })
            ];
            const gameTypeFilter = new filters_1.FilterListItem('type', -4, 'game.filter.gameTypeId.label', 'game.filter.gameTypeId.label', 'gameTypeId', enableQuickDraw ? filters_1.SelectionType.MULTIPLE : filters_1.SelectionType.SINGLE, enableQuickDraw ? allGameTypeFilters : fixedGameTypeFilter);
            const gameTopPrizeFilter = new filters_1.FilterListItem('topprize', -2, 'game.filter.topPrize.label', 'game.filter.topPrize.label', 'queryTopPrize', filters_1.SelectionType.MULTIPLE, [
                new filters_1.Filter({
                    order: 0,
                    isSelected: false,
                    name: 'game.filter.topPrize.f1000000',
                    value: 'f1000000'
                }),
                new filters_1.Filter({
                    order: 1,
                    isSelected: false,
                    name: 'game.filter.topPrize.f500000',
                    value: 'f500000'
                }),
                new filters_1.Filter({
                    order: 2,
                    isSelected: false,
                    name: 'game.filter.topPrize.f250000-t500000',
                    value: 'f250000-t500000'
                }),
                new filters_1.Filter({
                    order: 3,
                    isSelected: false,
                    name: 'game.filter.topPrize.f100000-t250000',
                    value: 'f100000-t250000'
                }),
                new filters_1.Filter({
                    order: 4,
                    isSelected: false,
                    name: 'game.filter.topPrize.f50000-t100000',
                    value: 'f50000-t100000'
                }),
                new filters_1.Filter({
                    order: 5,
                    isSelected: false,
                    name: 'game.filter.topPrize.f5000-t50000',
                    value: 'f5000-t50000'
                }),
                new filters_1.Filter({
                    order: 6,
                    isSelected: false,
                    name: 'game.filter.topPrize.t5000',
                    value: 't5000'
                }),
                new filters_1.Filter({
                    order: 7,
                    isSelected: false,
                    name: 'game.filter.topPrize.other',
                    value: 'other'
                })
            ]);
            if (config_1.react_core_config.internalConfig.showGameTypeFilter) {
                this.push(gameTypeFilter);
            }
            this.push(gameStatusFilter);
            this.push(gameTopPrizeFilter);
            return this;
        };
        this.addGameRetailerPrices = (gameRetailerPrices) => {
            const filters = gameRetailerPrices.map(x => new filters_1.Filter({
                name: `$${x}`,
                value: x,
                isSelected: false,
                order: x
            }));
            const newFilterListItem = new filters_1.FilterListItem('price', -1, 'Ticket Price', 'Ticket Price', 'retailPrice', filters_1.SelectionType.MULTIPLE, filters);
            return this.copyFromArray([...this, newFilterListItem], {});
        };
        this.addGameType = (gameTypes) => {
            const filters = gameTypes.map(x => new filters_1.Filter({
                name: x.name,
                value: x.id,
                isSelected: false,
                order: x.id
            }));
            const newFilterListItem = new filters_1.FilterListItem('type', 0, 'Game Type', 'Game Type', 'gameTypeId', filters_1.SelectionType.MULTIPLE, filters);
            return this.copyFromArray([...this, newFilterListItem], {});
        };
        this.addGameTags = (gameTagTypes, gameTags) => {
            const list = gameTagTypes.map(gameTagType => {
                const filters = gameTags
                    .filter(x => x.gameTagTypeId === gameTagType.id)
                    .map(x => new filters_1.Filter({
                    name: x.name,
                    value: x.id,
                    isSelected: false,
                    order: x.id
                }));
                return new filters_1.FilterListItem('tag', gameTagType.id, gameTagType.name, gameTagType.name, `query${gameTagType.name
                    .split(' ')
                    .map(x => _.startCase(x.toLowerCase()))
                    .join('')}`, filters_1.SelectionType.MULTIPLE, filters);
            });
            return this.copyFromArray([...this, ...list], {});
        };
        this.buildFilterQuery = () => [
            ...this.filter(x => x.type === 'tag' && x.filter(y => y.isSelected).length > 0).map(x => `${x.value}=${x
                .filter(y => y.isSelected)
                .map(y => y.value)
                .join(',')}`),
            ...this.filter(x => x.type === 'type' && x.filter(y => y.isSelected).length > 0).map(x => `${x.value}.in=${x
                .filter(y => y.isSelected)
                .map(y => y.value)
                .join(',')}`),
            ...this.filter(x => x.type === 'date' && x.filter(y => y.isSelected).length > 0).map(x => {
                const filters = x.filter(y => y.isSelected).map(y => this.handleFilter(y));
                return filters.length > 1 ? `query=${filters.join(',').replace(/&/g, ' ')}` : filters.join('&');
            }),
            ...this.filter(x => x.type === 'topprize' && x.filter(y => y.isSelected).length > 0).map(x => `${x.value}=${x
                .filter(y => y.isSelected)
                .map(y => y.value)
                .join(',')}`),
            ...this.filter(x => x.type === 'price' && x.filter(y => y.isSelected).length > 0).map(x => `${x.value}.in=${x
                .filter(y => y.isSelected)
                .map(y => y.value)
                .join(',')}`)
        ].join('&');
        this.handleFilter = (filter) => {
            let query;
            switch (filter.dateFilterType) {
                case 'new':
                    const period = (0, TimeUtil_1.nowUtc)().subtract(filterConfig.NEW_GAME_PERIOD, 'days');
                    query = `playBegin.greaterThanOrEqual=${period.toISOString()}&playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`;
                    break;
                case 'active':
                    query = `playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}&active.equals=true`;
                    break;
                case 'upcoming':
                    const upcomingCutoff = (0, TimeUtil_1.nowUtc)().add(filterConfig.UPCOMING_GAME_PERIOD, 'days');
                    query = `playBegin.greaterThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}&playBegin.lessThanOrEqual=${upcomingCutoff.toISOString()}`;
                    break;
                case 'endingSoon':
                    const endingCutoff = (0, TimeUtil_1.nowUtc)().add(filterConfig.UPCOMING_GAME_PERIOD, 'days');
                    query = `playEnd.lessThanOrEqual=${endingCutoff.toISOString()}&playEnd.greaterThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`;
                    break;
                case 'ended':
                    query = `playEnd.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`;
                    break;
                default:
                    const defaultPeriod = (0, TimeUtil_1.nowUtc)().subtract(filterConfig.NEW_GAME_PERIOD, 'days');
                    query = `playBegin.greaterThanOrEqual=${defaultPeriod.toISOString()}&playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`;
                    break;
            }
            return query;
        };
    }
}
GameFilterList.fromArrayWithOptions = (filters, options = {}) => new GameFilterList().copyFromArray(filters, options);
GameFilterList.fromArray = (filters, gameStatuses, topPrizes, gameTypes) => new GameFilterList().copyFromArray(filters, { gameStatuses, topPrizes, gameTypes });
GameFilterList.fixedFilters = (enableQuickDraw) => new GameFilterList().createFixedFilters(enableQuickDraw);
exports.default = GameFilterList;
//# sourceMappingURL=GameFilterList.js.map